const _excluded = ["onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import { Card, MenuItem, TextField, Typography } from 'seagull';
import styles from "./EditAgreementModal.module.scss";
import { useEditAgreementForm } from "./EditAgreementModal.utils";
import { getAllowManualPaymentsChangeBullet, getAmendmentsApprovalMethodChangeBullet, getCoverCCFeesChangeBullet, getInvoicesApprovalMethodChangeBullet, getNetTermsChangeBullet, netTermsSelectOptions } from "../../business-logic/amendmentsLogic";
import { Controller } from 'react-hook-form';
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import AmendmentChanges from "../AmendmentChanges/AmendmentChanges";
import { approvalMethodNoticePeriodModel, relationshipModel } from "../../models";
import { AllowManualPaymentsCheckbox, ApprovalMethodNoticePeriodField, CoverCreditCardFeesSelector, validateApprovalMethodNoticePeriod } from "../agreement-controllers";
import LegalTermsDropdown from "../LegalTermsDropdown/LegalTermsDropdown";
import { getAutoApprovalRange } from "../../business-logic/autoApprovalLogic";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
export const Section = props => /*#__PURE__*/React.createElement(Card, {
  autoHeight: true,
  padding: "m",
  title: props.title
}, /*#__PURE__*/React.createElement("div", {
  className: styles.sectionContent
}, props.children));
export const SettingsField = props => /*#__PURE__*/React.createElement("div", {
  className: styles.settingsField
}, props.children);
export function EditNetTerms(props) {
  const {
    relationship
  } = props;
  const {
    watch,
    control
  } = useEditAgreementForm();
  const updatedNetTerms = watch('updatedNetTerms');
  const netTermsChangeBullet = getNetTermsChangeBullet(relationship, updatedNetTerms);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "updatedNetTerms",
    render: p => {
      const _connectControllerToT = connectControllerToTextField(p),
        {
          onChange: _onChange
        } = _connectControllerToT,
        rest = _objectWithoutProperties(_connectControllerToT, _excluded);
      return /*#__PURE__*/React.createElement(SettingsField, null, /*#__PURE__*/React.createElement(Typography, null, "Set the number of days the payment is due after the invoice date"), /*#__PURE__*/React.createElement(TextField, _extends({
        select: true,
        menuMaxHeight: 200,
        width: 280,
        testid: "edit-net-terms",
        onChange: e => _onChange(+e.target.value)
      }, rest), netTermsSelectOptions.map(_ref => {
        let {
          value,
          text
        } = _ref;
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: value.toString(),
          key: value,
          "data-testid": "net-terms-opt-".concat(value)
        }, text);
      })), netTermsChangeBullet && /*#__PURE__*/React.createElement(AmendmentChanges, {
        disableNote: true,
        disableBorderRadius: true,
        items: [netTermsChangeBullet],
        isUnsaved: p.fieldState.isDirty,
        testid: "net-terms-changes",
        autoApprovalDate: relationshipModel.updatedNetTermsAutoApprovalDate(relationship),
        onDiscard: () => _onChange(relationship.netTerms)
      }));
    }
  });
}
export function EditCCFees(props) {
  const {
    relationship
  } = props;
  const {
    control,
    watch
  } = useEditAgreementForm();
  const coverCreditCardFees = watch('coverCreditCardFees');
  const changeBullet = getCoverCCFeesChangeBullet(relationship, coverCreditCardFees);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "coverCreditCardFees",
    render: _ref2 => {
      let {
        field: {
          value,
          onChange
        },
        fieldState: {
          isDirty
        }
      } = _ref2;
      return /*#__PURE__*/React.createElement(SettingsField, null, /*#__PURE__*/React.createElement(CoverCreditCardFeesSelector, {
        testid: "cc-fees",
        vendorBusinessName: relationshipModel.vendorName(relationship),
        clientBusinessName: relationshipModel.customerName(relationship),
        value: value,
        onChange: onChange
      }), changeBullet && /*#__PURE__*/React.createElement(AmendmentChanges, {
        disableNote: true,
        disableBorderRadius: true,
        items: [changeBullet],
        isUnsaved: isDirty,
        testid: "cc-fees-changes",
        autoApprovalDate: relationshipModel.updatedIsVendorCoveringCCFeeAutoApprovalDate(relationship),
        onDiscard: () => onChange(relationshipModel.isVendorCoveringCCFee(relationship))
      }));
    }
  });
}
export function EditLegalTerms(props) {
  const {
    relationship,
    legalTermsDocuments,
    onLegalTermsUpload
  } = props;
  const {
    watch,
    setValue
  } = useEditAgreementForm();
  const selectedLegalTermsId = watch('selectedLegalTermsId');
  const availableLegalDocs = useMemo(() => {
    if (!legalTermsDocuments) return [];
    return legalTermsDocuments.some(_ref3 => {
      let {
        id
      } = _ref3;
      return relationship.legalTerms.id === id;
    }) ? legalTermsDocuments : legalTermsDocuments.concat([relationship.legalTerms]);
  }, [legalTermsDocuments, relationship]);
  const selectedLegalTerms = availableLegalDocs.find(_ref4 => {
    let {
      id
    } = _ref4;
    return id === selectedLegalTermsId;
  });
  return /*#__PURE__*/React.createElement(SettingsField, null, /*#__PURE__*/React.createElement(LegalTermsDropdown, {
    showViewTosButton: true,
    label: "Terms & Conditions",
    selectedLegalTerms: selectedLegalTerms,
    legalTerms: availableLegalDocs,
    onUpload: onLegalTermsUpload,
    onChange: id => {
      setValue('selectedLegalTermsId', id, {
        shouldDirty: true
      });
    }
  }), selectedLegalTermsId !== relationship.legalTerms.id && /*#__PURE__*/React.createElement(AmendmentChanges, {
    isUnsaved: true,
    disableNote: true,
    disableBorderRadius: true,
    items: selectedLegalTerms ? [{
      text: "Terms & Conditions changed to ".concat(selectedLegalTerms.name)
    }] : [],
    testid: "legal-terms-changes",
    autoApprovalDate: null,
    onDiscard: () => {
      setValue('selectedLegalTermsId', relationship.legalTerms.id, {
        shouldDirty: true
      });
    }
  }));
}
const EditApprovalMethodNoticePeriod = _ref5 => {
  let {
    info,
    text,
    testid,
    fieldName,
    relationship,
    autoApprovalDate,
    getApprovalMethodChangeBullet
  } = _ref5;
  const {
    control,
    watch
  } = useEditAgreementForm();
  const approvalMethod = watch(fieldName);
  const noticePeriodDays = approvalMethodNoticePeriodModel.noticePeriodDays(approvalMethod);
  const changeBullet = getApprovalMethodChangeBullet(relationship[fieldName], approvalMethod);
  return /*#__PURE__*/React.createElement(Controller, {
    name: fieldName,
    control: control,
    rules: {
      validate: value => validateApprovalMethodNoticePeriod(approvalMethodNoticePeriodModel.isAutoApproval(value), approvalMethodNoticePeriodModel.noticePeriodDays(value) || '')
    },
    render: _ref6 => {
      let {
        field: {
          value,
          onChange
        },
        fieldState: {
          isDirty
        }
      } = _ref6;
      return /*#__PURE__*/React.createElement(SettingsField, null, /*#__PURE__*/React.createElement(ApprovalMethodNoticePeriodField, {
        testid: testid,
        info: info,
        text: text,
        enabled: approvalMethodNoticePeriodModel.isAutoApproval(value),
        noticePeriod: noticePeriodDays != null ? noticePeriodDays : '',
        onToggle: enabled => {
          if (enabled) {
            const {
              maxDays
            } = getAutoApprovalRange();
            onChange(approvalMethodNoticePeriodModel.makeAutoApprovalMethodNoticePeriod(maxDays));
          } else {
            onChange(approvalMethodNoticePeriodModel.makeManualApprovalMethodNoticePeriod());
          }
        },
        onChangePeriod: noticePeriod => {
          if (noticePeriod === '') return;
          onChange(approvalMethodNoticePeriodModel.makeAutoApprovalMethodNoticePeriod(noticePeriod));
        }
      }), changeBullet && /*#__PURE__*/React.createElement(AmendmentChanges, {
        disableNote: true,
        disableBorderRadius: true,
        items: [changeBullet],
        isUnsaved: isDirty,
        testid: "".concat(testid, "-changes"),
        autoApprovalDate: autoApprovalDate,
        onDiscard: () => onChange(relationship[fieldName])
      }));
    }
  });
};
export const EditAmendmentsApprovalMethod = _ref7 => {
  let {
    relationship
  } = _ref7;
  const {
    AUTO_APPROVE_INVOICE
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement(EditApprovalMethodNoticePeriod, {
    info: AUTO_APPROVE_INVOICE ? "Amendments will take effect automatically if the client doesn't disable within the notice period set. Amended invoices issued during the notice period will require client approval." : "Amendments will take effect automatically if the client doesn't decline within the set time period. Amended invoices issued during notice period will require client approval.",
    text: AUTO_APPROVE_INVOICE ? 'Automatically approve amendments after a defined period' : 'Enable amendment auto-approval with a notice period',
    testid: 'amendments-approval-method',
    fieldName: 'amendmentsApprovalMethod',
    relationship: relationship,
    autoApprovalDate: relationshipModel.updatedAmendmentsApprovalMethodAutoApprovalDate(relationship),
    getApprovalMethodChangeBullet: getAmendmentsApprovalMethodChangeBullet
  });
};
export const EditInvoicesApprovalMethod = _ref8 => {
  let {
    relationship
  } = _ref8;
  return /*#__PURE__*/React.createElement(EditApprovalMethodNoticePeriod, {
    info: "Invoices that require client approval will be approved automatically if the client doesn't disable within the notice period set.",
    text: "Automatically approve out-of-scope charges after a defined period",
    testid: 'invoices-approval-method',
    fieldName: 'invoicesApprovalMethod',
    relationship: relationship,
    autoApprovalDate: relationshipModel.updatedInvoicesApprovalMethodAutoApprovalDate(relationship),
    getApprovalMethodChangeBullet: getInvoicesApprovalMethodChangeBullet
  });
};
export function EditAllowManualPayments(props) {
  const {
    relationship
  } = props;
  const {
    control,
    watch
  } = useEditAgreementForm();
  const allowManualPayments = watch('allowManualPayments');
  const changeBullet = getAllowManualPaymentsChangeBullet(relationship, allowManualPayments);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "allowManualPayments",
    render: _ref9 => {
      let {
        field: {
          value,
          onChange: _onChange2
        },
        fieldState: {
          isDirty
        }
      } = _ref9;
      return /*#__PURE__*/React.createElement(SettingsField, null, /*#__PURE__*/React.createElement(AllowManualPaymentsCheckbox, {
        value: value,
        onChange: newValue => _onChange2(newValue)
      }), changeBullet && /*#__PURE__*/React.createElement(AmendmentChanges, {
        disableNote: true,
        disableBorderRadius: true,
        items: [changeBullet],
        isUnsaved: isDirty,
        testid: "allow-manual-payments-changes",
        autoApprovalDate: relationshipModel.updatedAllowManualPaymentsAutoApprovalDate(relationship),
        onDiscard: () => _onChange2(relationship.allowManualPayments)
      }));
    }
  });
}